import styled from "styled-components";

// Estilos comunes a las pantallas del alta de empresa
export const Cont = styled.div`
    grid-area: main;
    background-color: ${(props) => props.theme.palette.white};
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
`;

export const MainCont = styled.div`
    padding: 20px 30px 30px 55px;
    display: flex;
    flex-direction: column;
    gap: 28px;

    @media screen and (max-width: 599px)
    {
        padding: 20px 16px 40px 16px;
    }
`;

export const BackLink = styled.button`
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    border: 0;
    background: transparent;
    font: inherit;
    font-size: 15px;
    color: #5f7172;
    cursor: pointer;

    &:hover
    {
        color: ${(props) => props.theme.palette.themePrimary};
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 28px;
    border-bottom: 1px solid #eff4f6;
    cursor: default;

    h1
    {
        margin: 0;
        font-size: 30px;
        font-weight: 800;
        color: #2a4143;
    }

    h2
    {
        margin: 0;
        font-size: 22px;
        font-weight: 400;
        color: #5f7172;
    }
`;

export const TwoColumnGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px 24px;

    @media screen and (max-width: 767px)
    {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const TestActionRow = styled.div`
    display: flex;
    justify-content: center;
`;

export const FormFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    padding: 24px 32px;
    border: 1px solid #E3E8EB;
    border-radius: 24px;
    background: #ffffff;

    @media screen and (max-width: 767px)
    {
        flex-direction: column;
        align-items: stretch;
        padding: 20px 16px;
    }
`;

export const ErrorNotice = styled.div`
    padding: 16px 20px;
    border-radius: 14px;
    border: 1px solid #F1B4B9;
    background: #FDECEE;
    color: #a4262c;
    font-size: 14px;

    b
    {
        font-size: 15px;
    }

    p
    {
        margin: 6px 0 0;
    }
`;

export const ResultPanel = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    padding: 24px 28px;
    border-radius: 20px;
    border: 1px solid #9FD1AE;
    background: #F4FBF6;
    color: #237A3E;

    > i
    {
        font-size: 28px;
    }

    > div
    {
        flex-grow: 1;
    }

    b
    {
        font-size: 17px;
        color: #2a4143;
    }

    p
    {
        margin: 4px 0 0;
        color: #5f7172;
    }

    @media screen and (max-width: 767px)
    {
        flex-direction: column;
        align-items: stretch;
        text-align: center;
    }
`;

export const WarningBanner = styled.div`
    display: flex;
    gap: 14px;
    align-items: flex-start;
    background: #FFF8E1;
    border: 1px solid #F2D27A;
    border-radius: 14px;
    padding: 16px 20px;
    font-size: 15px;
    font-weight: 600;
    color: #7A5B00;
    cursor: default;

    i
    {
        flex-shrink: 0;
        font-size: 20px;
        line-height: 1;
    }
`;

// Paso 2: formulario a la izquierda y resumen del pedido a la derecha
export const SubscriptionLayout = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
    gap: 24px;
    align-items: start;

    > section
    {
        background: #ffffff;
        border: 1px solid #E3E8EB;
    }

    @media screen and (max-width: 991px)
    {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const OrderSummary = styled.div`
    background: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
    color: #ffffff;
    border-radius: 24px;
    padding: 28px 32px;
    cursor: default;

    h3
    {
        margin: 0 0 20px;
        font-size: 20px;
        font-weight: 700;
        color: #ffffff;
    }

    dl
    {
        margin: 0 0 24px;
    }

    /* Blanco explícito: los estilos globales de h3/dt/dd no deben dejar el texto en gris sobre el fondo de color */
    dt, dd
    {
        color: #ffffff;
    }

    dl > div
    {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        padding: 8px 0;
        font-size: 15px;
    }

    dl > div.small
    {
        font-size: 13px;
    }

    dl > div.total
    {
        font-size: 18px;
        font-weight: 700;
    }

    dt, dd
    {
        margin: 0;
    }

    hr
    {
        border: 0;
        border-top: 1px solid rgba(255, 255, 255, 0.4);
        margin: 8px 0;
    }

    button
    {
        width: 100%;
        height: 56px;
        border: 0;
        border-radius: 999px;
        background: #ffffff;
        color: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
        font: inherit;
        font-size: 17px;
        font-weight: 600;
        cursor: pointer;
    }

    button:disabled
    {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const OrderNote = styled.p`
    margin: 16px 4px 16px;
    font-size: 14px;
    line-height: 1.5;
    color: #5f7172;
`;

export const ResultActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-end;
    flex-basis: 100%;

    @media screen and (max-width: 767px)
    {
        flex-direction: column;
    }
`;

export const SubmitNotice = styled.div`
    padding: 10px 14px;
    border-radius: 4px;
    border-left: 4px solid #1565c0;
    background-color: rgba(21, 101, 192, 0.08);
    color: #1565c0;
    font-size: 14px;
`;

export const InfoBanner = styled.div`
    display: flex;
    gap: 14px;
    align-items: flex-start;
    background: #EEF5FB;
    border: 1px solid #9FC3E6;
    border-radius: 14px;
    padding: 16px 20px;
    font-size: 15px;
    font-weight: 600;
    color: #1F4E79;
    cursor: default;

    i
    {
        flex-shrink: 0;
        font-size: 20px;
        line-height: 1;
    }
`;
